import { Flags } from '@metarhia/common';

import {
  CheckboxGroupFormControlViewModel,
  CheckboxGroupValueType,
  SetCheckboxGroupFormControlViewModel,
} from '../../view-model/FormControlViewModel';

const updateCheckboxGroupWithFlags = (
  control: CheckboxGroupFormControlViewModel,
  value: Array<string | number> | null
): string | null => {
  const enumValues = control.options.map(option => option.value);
  const EnumFlags = Flags.from(...enumValues);
  const flags = new EnumFlags();

  if (value === null) {
    return value;
  }

  for (const v of value) {
    flags.set(v);
  }

  return flags.value.toString();
};

const updateCheckboxGroupWithSet = (
  _control: SetCheckboxGroupFormControlViewModel,
  value: Array<string | number> | null
): string | null => {
  if (value === null) {
    return value;
  }

  return value.join(';');
};

const updateCheckboxGroup = (
  control: any,
  value: Array<string | number> | null
): string | null => {
  if (value !== null && !Array.isArray(value)) {
    throw new TypeError(
      'Wrong type of CheckboxGroup value. Must be an array or null'
    );
  }

  return control.valueType === CheckboxGroupValueType.FLAGS
    ? updateCheckboxGroupWithFlags(control, value)
    : updateCheckboxGroupWithSet(control, value);
};

export default updateCheckboxGroup;
